import React from 'react'

import PerfectScrollbar from 'react-perfect-scrollbar'
import { Box, Chip, Hidden, Paper, TablePagination } from '@material-ui/core'

import { LoadingFeedback } from 'components'
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from 'components/Table'

import { ActionButtons } from './components'

import * as service from 'service'
import constants from 'constants/index'
import helpers from 'helpers'

import useFetch from 'hooks/useFetch'
import usePagination from 'hooks/usePagination'
import useStyles from './styles'

const ChangesManagementTable = ({ filter }) => {
  const { STATUSES } = constants.changesManagement

  const classes = useStyles()

  const { perPage, page, handleChangePage, handleChangeRowsPerPage } =
    usePagination(10)

  const { response, isLoading } = useFetch(
    service.dponet.changesManagement.get,
    { ...filter?.filters, perPage, page },
    [filter?.filters, perPage, page],
  )

  const changesManagements = response?.data?.changesManagements || []

  return (
    <>
      <LoadingFeedback open={isLoading} />
      <Paper>
        <Box width="100%">
          <PerfectScrollbar
            options={{ wheelPropagation: false, useBothWheelAxes: true }}
          >
            <Table
              size="small"
              noWrap
              emptyMessage="Nenhuma gestão de mudança encontrada."
            >
              <TableHead>
                <TableRow>
                  <TableCell>ID</TableCell>
                  <TableCell>Nome</TableCell>
                  <TableCell>Responsável</TableCell>
                  <TableCell>Prazo</TableCell>
                  <TableCell>Status</TableCell>
                  <TableCell align="right">Ações</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {changesManagements?.map((changesManagement) => (
                  <TableRow key={changesManagement?.id}>
                    <TableCell>{changesManagement?.id}</TableCell>
                    <TableCell>{changesManagement?.name}</TableCell>
                    <TableCell>
                      {changesManagement?.responsible?.name}
                    </TableCell>
                    <TableCell>
                      {helpers.formatters.date(changesManagement?.deadline)}
                    </TableCell>
                    <TableCell>
                      <Chip
                        size="small"
                        className={classes[changesManagement?.status]}
                        label={STATUSES[changesManagement?.status]}
                      />
                    </TableCell>
                    <TableCell align="right">
                      <ActionButtons changesManagement={changesManagement} />
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </PerfectScrollbar>
        </Box>
        <TablePagination
          component="div"
          count={response?.data?.meta?.totalCount || 0}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
          page={page - 1}
          rowsPerPage={perPage}
          rowsPerPageOptions={[5, 10, 25, 100]}
          labelRowsPerPage={<Hidden smDown>Por página</Hidden>}
          nextIconButtonProps={{ size: 'small' }}
          backIconButtonProps={{ size: 'small' }}
        />
      </Paper>
    </>
  )
}

export default ChangesManagementTable
